import { render, staticRenderFns } from "./FontTool.vue?vue&type=template&id=4fa7cdd4&"
import script from "./FontTool.vue?vue&type=script&lang=js&"
export * from "./FontTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports